import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Reveal, PageHero } from "@/components/shared";
import { HandHeart } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const interests = ["Namma Mane — Elders Care", "Tavaru — Women Empowerment", "Thottilu — Children Welfare", "Nalanda Study Centre", "Dhamma & Meditation", "Medical Camps", "Media & Communications", "General Seva"];

const Volunteer = () => {
  const [form, setForm] = useState({ name: "", email: "", phone: "", city: "", interest: interests[0], message: "" });
  const [sending, setSending] = useState(false);

  const update = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await axios.post(`${API}/volunteer`, {
        name: form.name,
        email: form.email,
        phone: form.phone || null,
        city: form.city || null,
        interest: form.interest,
        message: form.message,
      });
      toast.success("Thank you for stepping forward. We will be in touch soon.");
      setForm({ name: "", email: "", phone: "", city: "", interest: interests[0], message: "" });
    } catch (err) {
      toast.error("Something went wrong. Please try again or email us directly.");
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      <PageHero
        testId="volunteer-hero"
        eyebrow="Volunteer"
        title="Give the Gift of Your Time"
        intro="Seva — selfless service — is the heartbeat of IBMCT. Whether you can offer a few hours a week or a specialist skill, there is a place for you here."
      />

      <section className="bg-ivory" data-testid="volunteer-form-section">
        <div className="max-w-3xl mx-auto px-5 lg:px-8 py-16 lg:py-24">
          <Reveal>
            <div className="flex items-center gap-4 mb-8">
              <HandHeart size={30} strokeWidth={1.5} className="text-saffron" aria-hidden="true" />
              <h2 className="text-[28px] sm:text-3xl font-semibold text-charcoal">Volunteer Application</h2>
            </div>
            <form onSubmit={submit} className="space-y-6" data-testid="volunteer-form">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="vol-name" className="block font-sans font-semibold text-sm text-charcoal mb-2">Full Name *</label>
                  <input id="vol-name" name="name" required value={form.name} onChange={update} className="input-field" placeholder="Your name" data-testid="volunteer-name-input" />
                </div>
                <div>
                  <label htmlFor="vol-email" className="block font-sans font-semibold text-sm text-charcoal mb-2">Email *</label>
                  <input id="vol-email" name="email" type="email" required value={form.email} onChange={update} className="input-field" placeholder="you@example.com" data-testid="volunteer-email-input" />
                </div>
                <div>
                  <label htmlFor="vol-phone" className="block font-sans font-semibold text-sm text-charcoal mb-2">Phone (optional)</label>
                  <input id="vol-phone" name="phone" type="tel" value={form.phone} onChange={update} className="input-field" placeholder="+91 …" data-testid="volunteer-phone-input" />
                </div>
                <div>
                  <label htmlFor="vol-city" className="block font-sans font-semibold text-sm text-charcoal mb-2">City (optional)</label>
                  <input id="vol-city" name="city" value={form.city} onChange={update} className="input-field" placeholder="Your city" data-testid="volunteer-city-input" />
                </div>
              </div>
              <div>
                <label htmlFor="vol-interest" className="block font-sans font-semibold text-sm text-charcoal mb-2">Area of Interest *</label>
                <select id="vol-interest" name="interest" value={form.interest} onChange={update} className="input-field" data-testid="volunteer-interest-select">
                  {interests.map((i) => (
                    <option key={i} value={i}>{i}</option>
                  ))}
                </select>
              </div>
              <div>
                <label htmlFor="vol-message" className="block font-sans font-semibold text-sm text-charcoal mb-2">Tell Us About Yourself *</label>
                <textarea id="vol-message" name="message" required rows={5} value={form.message} onChange={update} className="input-field" placeholder="Your skills, availability, and what draws you to serve…" data-testid="volunteer-message-input" />
              </div>
              <button type="submit" disabled={sending} className="btn btn-primary disabled:opacity-60" data-testid="volunteer-submit-button">
                {sending ? "Submitting…" : "Submit Application →"}
              </button>
            </form>
          </Reveal>
        </div>
      </section>
    </>
  );
};

export default Volunteer;
